import { FaFileContract } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import CardNotificacaoBase from "./CardNotificacaoBase";

const CardAlvara = ({ notif }) => {
    const navigate = useNavigate();
    const info = notif.prestador_info;

    if (!info) return null;

    const dias = info.dias_para_vencimento;
    const diasTexto = dias === 1 ? "dia" : "dias";
    const color = dias <= 5 ? "danger" : dias <= 15 ? "warning" : "primary";

    const titulo = `Alvará vencendo em ${dias} ${diasTexto}`;
    const descricao = [
        info.nome,
        info.cpf_cnpj && `(${info.cpf_cnpj})`,
        info.programa_nome && `· ${info.programa_nome}`,
    ]
        .filter(Boolean)
        .join(" ");

    let dataDisplay = `-`;
    if (notif.data_criacao) {
        try {
            dataDisplay = new Date(notif.data_criacao).toLocaleString("pt-BR");
        } catch (e) {
            dataDisplay = notif.data_criacao;
        }
    }

    // Acrescenta a data de vencimento do alvará logo abaixo
    const descricaoFull = info.data_vencimento_alvara
        ? `${descricao} — Vencimento: ${info.data_vencimento_alvara}`
        : descricao;

    const handleClick = () => {
        navigate(`/prestadores/edit/${info.id}`);
    };

    return (
        <CardNotificacaoBase
            notificacao={notif}
            icon={<FaFileContract />}
            color={color}
            text={`text-${color}`}
            label={`Alvará (${dias} ${diasTexto})`}
            titulo={titulo}
            descricao={descricaoFull}
            dataFormatada={dataDisplay}
            onClick={handleClick}
        />
    );
};

export default CardAlvara;
